/**
 * 数据状态枚举
 */
export enum SceneDataStatus {
  NORMAL = 'NORMAL',         // 正常
  DELETED = 'DELETED',       // 删除
  ARCHIVED = 'ARCHIVED'      // 归档
}

/**
 * 内景/外景枚举
 */
export enum SceneInteriorExterior {
  INTERIOR = 'INTERIOR',           // 内景
  EXTERIOR = 'EXTERIOR',           // 外景
  INTERIOR_EXTERIOR = 'INTERIOR_EXTERIOR'  // 内外景
}

/**
 * 日景/夜景枚举
 */
export enum SceneDayNight {
  MORNING = 'MORNING',       // 晨
  DAY = 'DAY',               // 日
  NIGHT = 'NIGHT',           // 夜
  DUSK = 'DUSK'              // 昏
}

/**
 * 场次信息类型
 */
export interface SceneInfo {
  sceneID: string;
  sceneCode?: string;
  sceneName?: string;
  sceneFilmID?: string;
  sceneBelongBreakdownID?: string;
  sceneCreatorID?: string;
  sceneCreateTime?: string;
  sceneUpdateTime?: string;
  sceneDataStatus: SceneDataStatus;
  scenePeriod?: string;
  sceneBudgetAmount?: number;
  scenePlot?: string;
  scenePlotSummary?: string;
  scenePlotDay?: string;
  scenePage?: number;
  scenePagesNumber?: number;
  sceneLocation?: string;
  sceneSet?: string;
  sceneInteriorExterior?: SceneInteriorExterior;
  sceneDayNight?: SceneDayNight;
}

/**
 * 查询场次参数类型
 */
export interface QuerySceneParams {
  sceneID?: string;
  sceneCode?: string;
  sceneName?: string;
  sceneFilmID?: string;
  sceneBelongBreakdownID?: string;
  sceneCreatorID?: string;
  sceneDataStatus?: SceneDataStatus;
  sceneInteriorExterior?: SceneInteriorExterior;
  sceneDayNight?: SceneDayNight;
  scenePlotDay?: string;
}

/**
 * 创建场次参数类型
 */
export interface CreateSceneParams {
  sceneCode?: string;
  sceneName?: string;
  sceneFilmID?: string;
  sceneBelongBreakdownID?: string;
  sceneCreatorID?: string;
  sceneDataStatus?: SceneDataStatus;
  scenePeriod?: string;
  sceneBudgetAmount?: number;
  scenePlot?: string;
  scenePlotSummary?: string;
  scenePlotDay?: string;
  scenePage?: number;
  scenePagesNumber?: number;
  sceneLocation?: string;
  sceneSet?: string;
  sceneInteriorExterior?: SceneInteriorExterior;
  sceneDayNight?: SceneDayNight;
}

/**
 * 更新场次参数类型
 */
export interface UpdateSceneParams {
  sceneCode?: string;
  sceneName?: string;
  sceneFilmID?: string;
  sceneBelongBreakdownID?: string;
  sceneCreatorID?: string;
  scenePeriod?: string;
  sceneBudgetAmount?: number;
  scenePlot?: string;
  scenePlotSummary?: string;
  scenePlotDay?: string;
  scenePage?: number;
  scenePagesNumber?: number;
  sceneLocation?: string;
  sceneSet?: string;
  sceneInteriorExterior?: SceneInteriorExterior;
  sceneDayNight?: SceneDayNight;
  sceneDataStatus?: SceneDataStatus;
}

/**
 * 扩展场次信息，包含用户姓名
 */
export interface SceneWithUserNames extends SceneInfo {
  sceneCreatorName?: string;
}

/**
 * 批量删除场次响应类型
 */
export interface BatchDeleteSceneResponse {
  deletedCount: number;
  errors: {
    id: string;
    error: string;
  }[];
}
